// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2Bt7R","subtitle":"styles_subtitle__1mGtq","quotes":"styles_quotes__3K5ft"};